import React from 'react';
import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaStar } from 'react-icons/fa';
import { useCart } from '../context/CartContext';
import { Helmet } from "react-helmet";

function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [showNotification, setShowNotification] = useState(false);

  const products = [
    {
      id: 1,
      name: 'Servizio Ritratto Premium',
      shortDescription: 'Sessione fotografica professionale con ritratti artistici di alta qualita in studio',
      description: 'Il nostro servizio di ritratto premium offre una sessione fotografica professionale completa in studio con illuminazione cinematografica. Include consulenza stilistica, 3 ore di shooting, 50 foto ritoccate professionalmente e album digitale premium. Catturiamo la tua essenza attraverso ritratti artistici che raccontano la tua storia unica.',
      price: 499.00,
      image: '/images/1.jpg',
      rating: 5
    },
    {
      id: 2,
      name: 'Pacchetto Famiglia Deluxe',
      shortDescription: 'Servizio fotografico completo per famiglie con sessione outdoor e indoor',
      description: 'Pacchetto fotografico familiare deluxe che comprende sessione outdoor in location esclusiva e sessione indoor in studio. Include 4 ore di shooting, consulenza pre-servizio, 80 foto ritoccate, stampe premium formato 30x40cm e album fotografico rilegato in pelle. Immortaliamo i momenti piu preziosi della vostra famiglia.',
      price: 799.00,
      image: '/images/2.jpg',
      rating: 5
    },
    {
      id: 3,
      name: 'Wedding Photography Elite',
      shortDescription: 'Copertura fotografica completa per matrimoni con servizio premium',
      description: 'Servizio fotografico elite per matrimoni che include copertura completa della giornata, dalla preparazione fino al ricevimento. Due fotografi professionisti, 10 ore di copertura, 200+ foto ritoccate artisticamente, video highlights cinematografico, album matrimoniale premium rilegato a mano e stampe artistiche su tela.',
      price: 2499.00,
      image: '/images/3.jpg',
      rating: 5
    },
    {
      id: 4,
      name: 'Corporate Branding Package',
      shortDescription: 'Servizio fotografico professionale per aziende e professionisti',
      description: 'Pacchetto completo per branding aziendale che include ritratti professionali del team, foto degli spazi aziendali, shooting di prodotti e materiale promozionale. Sessione di 5 ore, 100 foto ritoccate professionalmente, ottimizzazione per web e social media, e diritti commerciali completi.',
      price: 1299.00,
      image: '/images/4.jpg',
      rating: 5
    },
    {
      id: 5,
      name: 'Fashion Editorial Premium',
      shortDescription: 'Sessione fotografica editoriale fashion con styling professionale',
      description: 'Servizio editoriale fashion premium che include sessione fotografica in studio professionale con styling completo, makeup artist, hair stylist e consulenza fashion. 6 ore di shooting, 60 foto ritoccate ad alto livello, post-produzione artistica avanzata e portfolio digitale ottimizzato per pubblicazioni.',
      price: 1799.00,
      image: '/images/5.jpg',
      rating: 5
    }
  ];

  const product = products.find(p => p.id === parseInt(id));

  if (!product) {
    return (
      <div className="product-detail-container">
        <h1>Servizio non trovato</h1>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product);
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 3000);
  };

  const handleBuyNow = () => {
    addToCart(product);
    navigate('/checkout');
  };

  return (
    <>
      <Helmet>
        <title>Haridem - Photography Studio Premium | Servizi Fotografici Professionali</title>
        <meta name="description" content="Haridem Photography Studio - Servizi fotografici professionali premium, ritratti artistici, gallerie contemporanee e attrezzatura fotografica di alta qualita" />
      </Helmet>

      <div className="product-detail-container">
      {showNotification && (
        <div className="notification">
          Servizio aggiunto al carrello con successo!
        </div>
      )}
      
      <div className="product-detail-grid">
        <div className="product-detail-image-container">
          <img src={product.image} alt={product.name} className="product-detail-image" />
        </div>
        
        <div className="product-detail-info">
          <h1 className="product-detail-name">{product.name}</h1>
          
          <div className="product-rating">
            <div className="stars">
              {[...Array(5)].map((_, i) => (
                <FaStar key={i} />
              ))}
            </div>
            <span className="rating-text">(5.0) - Eccellente</span>
          </div>

          <p className="product-detail-price">€{product.price.toFixed(2)}</p>
          
          <p className="product-detail-description">{product.description}</p>

          <div className="product-actions">
            <button onClick={handleAddToCart} className="btn-primary">
              Aggiungi al Carrello
            </button>
            <button onClick={handleBuyNow} className="btn-secondary">
              Acquista Ora
            </button>
          </div>
        </div>
      </div>
    </div>
  
    </>);
}

export default ProductDetail;